module.exports = __webpack_public_path__ + "res/28-img_info_m.2fdd2fb15cb523f43861bd86aab535b8.png";